import { messageError } from '../../../../store/batchTicket/constants';
import { logoGenial } from '../../../RateManagement/RequestDetails/exportPdf';

import { coesTableTemplate } from './coes';
import { directTreasuryTableTemplate } from './directTreasury';
import { equitiesTableTemplate } from './equities';
import { fixedIncomeTableTemplate } from './fixedIncome';
import { fundsTableTemplate } from './funds';
import { styleTemplate } from './style';
import { batchTicketOrderResumePdfTemplateProps } from './types';

export const batchTicketOrderResumePdfTemplate = ({
  coesData,
  directTreasuryData,
  equitiesData,
  fixedIncomeData,
  fundsData,
  orderName,
  sendDate,
  totalValue,
}: batchTicketOrderResumePdfTemplateProps) => {
  const fundsTotalValue = fundsData.totalValue;
  const directTreasuryTotalValue = directTreasuryData.totalValue;
  const fixedIncomeTotalValue = fixedIncomeData.totalValue;
  const equitiesTotalValue = equitiesData.totalValue;
  const coesTotalValue = coesData.totalValue;

  const fixedIncomeSectionTemplate = fixedIncomeTableTemplate({
    totalValue: fixedIncomeTotalValue,
    assetCount: fixedIncomeData.offers?.length || 0,
    data: fixedIncomeData.offers,
  });

  const directTreasurySectionTemplate = directTreasuryTableTemplate({
    totalValue: directTreasuryTotalValue,
    assetCount: directTreasuryData.offers?.length || 0,
    data: directTreasuryData.offers,
  });

  const fundsSectionTemplate = fundsTableTemplate({
    totalValue: fundsTotalValue,
    assetCount: fundsData.offers?.length || 0,
    data: fundsData.offers,
  });

  const equitiesSectionTemplate = equitiesTableTemplate({
    totalValue: equitiesTotalValue,
    assetCount: equitiesData.offers?.length || 0,
    data: equitiesData.offers,
  });

  const coesSectionTemplate = coesTableTemplate({
    totalValue: coesTotalValue,
    assetCount: coesData.offers?.length || 0,
    data: coesData.offers,
  });

  return `
<!doctype html>
<html lang="en" dir="auto" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml"
  xmlns:o="urn:schemas-microsoft-com:office:office">

<head>
  <title>Resumo boleta em lote</title>
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:700,400,600" rel="stylesheet" type="text/css">
  <link href="https://fonts.googleapis.com/css?family=Inter:600,400" rel="stylesheet" type="text/css">
  <meta name="format-detection" content="telephone=no, date=no, address=no, email=no, url=no">
  <meta name="x-apple-disable-message-reformatting">
  <meta name="color-scheme" content="light dark">
  <meta name="supported-color-schemes" content="light dark">
  ${styleTemplate}
</head>

<body>
  <div class="container">
    <div class="content">
      <header>
        <strong class="header-title">Resumo da boleta</strong>
        ${logoGenial}
      </header>
      <div class="product-section">
        <div class="product-summary">
          <div class="card">
            <div class="card-header">
              <span class="card-title">Nome da ordem:</span>
              <span class="card-value">${orderName || messageError}</span>
            </div>
            <div class="divider"></div>
            <div class="card-header">
              <span class="card-title">Data de envio:</span>
              <span class="card-value">${sendDate || messageError}</span>
            </div>
          </div>
          <div class="total-value-card">
            <span class="total-value-title">Valor total</span>
            <span class="total-value">${totalValue || messageError}</span>
          </div>
        </div>
        <div class="divider"></div>
        <div class="product-details-header">
          <strong class="product-details-title">Detalhe do produto</strong>
        </div>
      </div>
      ${fixedIncomeSectionTemplate}
      ${directTreasurySectionTemplate}
      ${fundsSectionTemplate}
      ${equitiesSectionTemplate}
      ${coesSectionTemplate}
    </div>
  </div>
</body>
</html>`;
};
